<template>
  <a
    class="wa-fab"
    href="https://wa.me/919740639892?text=Hi%20Nexxt%20Gen%20Computers%2C%20I%20need%20help%20with%20a%20laptop%2Fcomputer%20repair."
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp"
  >
    <span class="wa-pulse" aria-hidden="true"></span>
    <span class="wa-tip">Need a repair? Chat with us</span>

    <svg class="robo" viewBox="0 0 64 64" width="40" height="40" aria-hidden="true">
      <!-- antenna -->
      <line class="ant-stem" x1="32" y1="10" x2="32" y2="17" />
      <circle class="ant-tip" cx="32" cy="8" r="3" />

      <!-- head / chip body -->
      <rect class="head" x="14" y="17" width="36" height="30" rx="9" />

      <!-- side "pins" (chip legs) -->
      <g class="pins">
        <line x1="14" y1="26" x2="9" y2="26" />
        <line x1="14" y1="37" x2="9" y2="37" />
        <line x1="50" y1="26" x2="55" y2="26" />
        <line x1="50" y1="37" x2="55" y2="37" />
      </g>

      <!-- face screen -->
      <rect class="screen" x="20" y="23" width="24" height="18" rx="5" />

      <!-- eyes -->
      <g class="eyes">
        <circle class="eye" cx="27" cy="32" r="2.6" />
        <circle class="eye" cx="37" cy="32" r="2.6" />
      </g>

      <!-- WhatsApp mini-badge -->
      <g class="wa-badge">
        <circle cx="49" cy="47" r="9" />
        <path class="wa-glyph" d="M49 42.6c-2.5 0-4.5 2-4.5 4.5 0 .8.2 1.55.6 2.2l-.65 2.35 2.4-.63c.62.34 1.33.53 2.1.53h.01c2.48 0 4.5-2.02 4.5-4.5s-2.02-4.87-4.46-4.87zm2.15 6.35c-.09.26-.53.5-.74.53-.19.03-.43.04-.69-.04-.16-.05-.36-.11-.62-.22-1.1-.47-1.81-1.57-1.86-1.64-.05-.07-.44-.59-.44-1.12 0-.53.28-.79.38-.9.1-.11.21-.13.28-.13l.2.003c.06.003.15-.024.24.18.09.21.31.73.34.78.03.05.04.12.01.19-.03.07-.05.11-.1.17l-.16.19c-.05.05-.1.11-.05.21.06.1.25.42.55.68.38.34.7.44.8.5.1.05.16.04.22-.03.06-.07.25-.3.32-.4.07-.1.14-.08.23-.05.09.03.6.28.7.33.1.05.17.08.19.12.03.05.03.26-.06.52z" />
      </g>
    </svg>
  </a>
</template>

<script>
export default { name: 'WhatsAppButton' }
</script>

<style scoped>
.wa-fab {
  position: fixed;
  right: clamp(16px, 3vw, 28px);
  bottom: clamp(16px, 3vw, 28px);
  z-index: 900;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 18px;
  background: radial-gradient(circle at 30% 25%, #1c1c22, #0e0e12);
  border: 1px solid rgba(242, 107, 78, 0.35);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5), 0 0 18px rgba(242, 107, 78, 0.22);
  text-decoration: none;
  animation: wa-in 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) 0.6s both,
             wa-float 3.4s ease-in-out 1.2s infinite;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}
.wa-fab:hover {
  transform: translateY(-3px) scale(1.05);
  border-color: var(--coral, #f26b4e);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.55), 0 0 26px rgba(242, 107, 78, 0.45);
}
.wa-fab:active { transform: scale(0.96); }

/* ---- robot SVG ---- */
.robo { display: block; overflow: visible; }
.robo line { stroke-linecap: round; }

.head {
  fill: #17171d;
  stroke: var(--coral, #f26b4e);
  stroke-width: 2;
}
.screen { fill: #0b0b0f; stroke: rgba(242, 107, 78, 0.4); stroke-width: 1; }

.pins { stroke: #55555f; stroke-width: 2; }

.ant-stem { stroke: var(--coral, #f26b4e); stroke-width: 2; }
.ant-tip {
  fill: var(--coral, #f26b4e);
  transform-origin: 32px 8px;
  transform-box: fill-box;
  animation: ant-blink 2s ease-in-out infinite;
}

/* glowing coral eyes that blink */
.eye {
  fill: var(--coral, #f26b4e);
  filter: drop-shadow(0 0 3px rgba(242, 107, 78, 0.9));
  transform-origin: center;
  transform-box: fill-box;
  animation: eye-blink 4s ease-in-out infinite;
}
.eyes {
  transform-origin: 32px 32px;
  transform-box: fill-box;
  animation: eye-look 5s ease-in-out infinite;
}

/* WhatsApp badge */
.wa-badge circle { fill: #25d366; }
.wa-glyph { fill: #fff; }

/* pulse ring behind button */
.wa-pulse {
  position: absolute;
  inset: 0;
  border-radius: 18px;
  border: 1.5px solid var(--coral, #f26b4e);
  animation: wa-ping 2.6s ease-out 1.6s infinite;
  z-index: -1;
}

/* hover tooltip */
.wa-tip {
  position: absolute;
  right: 72px;
  white-space: nowrap;
  background: #17171d;
  border: 1px solid rgba(242, 107, 78, 0.4);
  color: #f2f2f4;
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  letter-spacing: 0.4px;
  padding: 8px 12px;
  border-radius: 8px;
  opacity: 0;
  transform: translateX(8px);
  pointer-events: none;
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.wa-tip::after {
  content: '';
  position: absolute;
  top: 50%;
  right: -6px;
  transform: translateY(-50%);
  border-left: 6px solid #17171d;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
}
.wa-fab:hover .wa-tip { opacity: 1; transform: translateX(0); }

@keyframes wa-in {
  from { opacity: 0; transform: scale(0) translateY(20px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}
@keyframes wa-float {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-6px); }
}
@keyframes wa-ping {
  0%        { transform: scale(1); opacity: 0.6; }
  80%, 100% { transform: scale(1.5); opacity: 0; }
}
@keyframes eye-blink {
  0%, 44%, 52%, 100% { transform: scaleY(1); }
  48%                { transform: scaleY(0.1); }
}
@keyframes eye-look {
  0%, 30%, 100% { transform: translateX(0); }
  45%, 65%      { transform: translateX(2.5px); }
}
@keyframes ant-blink {
  0%, 100% { opacity: 1; filter: drop-shadow(0 0 2px rgba(242,107,78,0.8)); }
  50%      { opacity: 0.4; filter: none; }
}

@media (prefers-reduced-motion: reduce) {
  .wa-fab { animation: wa-in 0.4s ease both; }
  .wa-pulse, .eye, .eyes, .ant-tip { animation: none; }
}
</style>
